import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { TeamMember } from '../types';

interface AuthStore {
    user: TeamMember | null;
    token: string | null;
    isAuthenticated: boolean;
    login: (user: TeamMember, token: string) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
    persist(
        (set) => ({
            user: null,
            token: null,
            isAuthenticated: false,
            login: (user, token) => {
                localStorage.setItem('gastroflow_token', token);
                set({ user, token, isAuthenticated: true });
            },
            logout: () => {
                localStorage.removeItem('gastroflow_token');
                set({ user: null, token: null, isAuthenticated: false });
            },
        }),
        { name: 'gastroflow-auth' }
    )
);
